export interface ITableURLFilter {
  [table: string]: Record<string, string>;
}

function filterTokenFromURL(queryFilters: string | (string | null)[] | undefined): string {
  const encodedEmptyJSON = btoa('{}');

  if (!queryFilters) return encodedEmptyJSON;
  if (typeof queryFilters === 'string') return queryFilters;
  return queryFilters.filter(v => v)[0] || encodedEmptyJSON;
}

export function encodeURLParams(params: ITableURLFilter): string {
  return btoa(JSON.stringify(params));
}

export function decodeURLParams(queryFilters: string | (string | null)[] | undefined): ITableURLFilter {
  const token = filterTokenFromURL(queryFilters);
  try {
    return JSON.parse(atob(token));
  } catch (error) {
    return {};
  }
}
